import { companyApi } from '@/axios/company';
import PaginationSelector from './PaginationSelector';

type Params = Omit<Parameters<typeof companyApi.list>[0], 'pageIndex' | 'pageSize'>;
type TaskRecord = Awaited<ReturnType<typeof companyApi.list>>['records'][number];

const CompanySelector = ({
  params,
  placeholder = '请选择企业',
  value,
  onChange,
  multiple = false,
  defaultOptions = [],
}: {
  params?: Params;
  placeholder?: string;
  value?: string | string[];
  onChange?: (value: string | string[]) => void;
  multiple?: boolean;
  defaultOptions?: Array<{ label: string; value: string }>;
}) => {
  return (
    <PaginationSelector<TaskRecord, Params>
      fetchApi={(requestParams) => companyApi.list(requestParams)}
      params={params}
      optionTransform={(item) => ({
        value: item.companyId,
        label: item.companyName,
      })}
      searchParamKey="companyName"
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      multiple={multiple}
      defaultOptions={defaultOptions}
    />
  );
};

export default CompanySelector;
